import React from 'react';
import Config from '../config';
import {Grid, Row, Col} from 'react-bootstrap/lib';

const {gitLoginClientId: clientId} = Config;

const admin = () => {
  const rand = Math.floor(Math.random() * 100000000).toString();
  const href = `https://github.com/login/oauth/authorize?client_id=${clientId}&scope=read:org%20user:email&state=${rand}`;
  return (
    <Row>
      <Grid>
        <Col xs={12} className="text-center">
          <a href={href} className="btn btn-default">Log in as admin</a>
        </Col>
      </Grid>
    </Row>
  );
};

export default admin;



// WEBPACK FOOTER //
// ./src/admin/index.js